<app-header [label]="page_name"></app-header>
<app-ag-grid-list [delete_permission]="gs.user_role_data?.evaluation_management_examinations_delete" [list]="items" [colDefs]="columns" [itemName]="page_name" (fetch_new_list)="get_list($event)" (bulkDelete)="bulk_delete($event)">
  <div toolbar class="flex bg-white gap-4 items-center justify-between flex-wrap p-4 border-b border-gray-200">
    <div class="flex flex-1 gap-4 flex-wrap items-center">
      <app-select-input label="Academic Year" class="flex-1" [options]="dds.dropdown_list?.academic_list" [(ngModel)]="params.academic_year_id" (valueChange)="on_academic_year_change()"></app-select-input>
      <app-select-input label="University" [is_disabled]="gs.access_scope.locked.university" class="flex-1" [options]="dds.dropdown_list?.university_list" [(ngModel)]="params.university_id" (valueChange)="on_university_change()"></app-select-input>
      <app-select-input label="Level" class="flex-1" [options]="dds.dropdown_list?.level_list" [(ngModel)]="params.level_id" (valueChange)="onFilterChange()"></app-select-input>
    </div>
    <div class="flex gap-4 items-center">
      <app-search-input #searchbar (fetch_new_list)="get_list($event)"></app-search-input>
      <app-button color="bg-white border-primary text-primary" icon="bx bx-download" (click)="download()"></app-button>
      <app-dropdown-upload-button *ngIf="gs.user_role_data?.evaluation_management_examinations_add" [page_name]="page_name" (bulkUpload)="bulk_modal.open()" (singleUpload)="navigate_to_form()"></app-dropdown-upload-button>
    </div>
  </div>
</app-ag-grid-list>
<app-confirmation-popup #confirmation_delete_modal label="Delete {{page_name}}?" [delete_icon]="true" cancelText="No" confirmColor="bg-[#FA2912] text-[#FFFFFF]" confirmText="YES" [is_mandatory]="true" (confirm_modal_clicked)="delete()" (close_modal_clicked)="confirmation_delete_modal.close()">
  Are you sure you want to Delete Exam.
</app-confirmation-popup>
<app-confirmation-popup #confirmation_disabled_modal [enable_icon]="true" confirmColor="bg-[#FA2912] text-[#FFFFFF]" [is_mandatory]="true" (confirm_modal_clicked)="update_country(selected_ids.is_active)" (close_modal_clicked)="confirmation_delete_modal.close()">
  Are you sure you want to {{selected_ids.is_active == true? "Disable" :"Enable"}} Exam
</app-confirmation-popup>

<app-modal #bulk_modal label="Bulk Upload {{page_name | plural}}" sub_label="Add {{ page_name }} in Bulk">
  <app-bulk-upload [title]="page_name" [cancel]="bulk_modal" [accepted_type]="['.csv']" [max_file_sizeMB]="5" [bulk_columns]="bulk_columns" (submit)="bulk_upload($event.data,$event.spinner)"></app-bulk-upload>
</app-modal>

<app-modal #view_modal [label]="'View '+ page_name" width="md" (close_modal_clicked)="view_modal.close()">
  <div class="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Academic year</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.AcademicYear?.name || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">College</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.College?.name || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">University</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.University?.name || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Level Name</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.Level?.name || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Program Name</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.Program?.name || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Stream Name</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.Stream?.name || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Credits</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.credits || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">{{page_name}} Name</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.name || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">{{page_name}} Code</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.code || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Email</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.email || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Contact</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.contact || '—' }}</p>
    </div>
  </div>
</app-modal>
